<template>
  <div class="date-range-picker">
    <div class="booking-engine__dates__form cursor-pointer">
      <div class="booking-engine__dates__icon">
        <vb-icon
          :name="'calendar'"
          color="--primary"
          :size="20"
        />
      </div>
      <b-form-input
        :placeholder="dates_placeholder || 'Scegli le date'"
        class="vb-input"
      />
    </div>
    <div v-show="is_current" class="vc-wrapper">
      <v-date-picker
        is-range
        v-model="range"
        :key="range_key"
        :min-date="min_checkin_date"
        :max-date="max_date"
        :select-attribute="select_attrs"
        :drag-attribute="drag_attrs"
        @input="on_range_input"
      />
      <div class="picker-alert" v-if="disclaimer">
        <b-alert
          show
          variant="warning"
          size="xs"
          v-html="disclaimer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VCalendar from "v-calendar";
import moment from "moment";
import { formatDateDisplay } from './logic';
import { select_attrs, drag_attrs } from "@/utilities/calendar";

Vue.use(VCalendar);

export default {
  name: 'booking-engine-date-range-picker',
  props: {
    checkin_date: {
      type: String,
      required: true,
    },
    checkout_date: {
      type: String,
      default: '',
    },
    is_current: {
      type: Boolean,
      default: false,
    },
    min_checkin_date: {
      type: Date,
      required: true,
    },
    max_date: {
      type: Date,
      required: true,
    },
    disclaimer: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      range: {},
      select_attrs,
      drag_attrs,
    };
  },
  computed: {
    dates_placeholder() {
      if (!this.checkin_date) return '';
      let checkin = formatDateDisplay(this.checkin_date);
      let checkout = formatDateDisplay(this.checkout_date);
      if (!checkout) return checkin;
      return checkin + ' - ' + checkout;
    },
    range_key() {
      return (this.checkin_date || '') + '-' + (this.checkout_date || '');
    },
  },
  mounted() {
    if (this.checkin_date && this.checkout_date) {
      this.range = {
        start: moment(this.checkin_date, "YYYY-MM-DD")._d,
        end: moment(this.checkout_date, "YYYY-MM-DD")._d,
      };
    }
  },
  methods: {
    on_range_input(dates) {
      let checkin = moment(dates.start).format("YYYY-MM-DD");
      let checkout = moment(dates.end).format("YYYY-MM-DD");
      if (checkin === checkout) {
        checkout = moment(dates.end).add(1, "days").format("YYYY-MM-DD");
        this.range.end = moment(dates.end).add(1, "days").toDate();
      }
      this.$emit('update:checkin_date', checkin);
      this.$emit('update:checkout_date', checkout);
      this.$emit('dates-selected');
    },
  },
};
</script>

<style lang="scss" scoped>

  .date-range-picker {
    position: relative;

    .booking-engine__dates__form {
      position: relative;

      input {
        pointer-events: none;
        padding-left: $grid-gutter-20 * 2;
      }
    }

    .booking-engine__dates__icon {
      position: absolute;
      top: 50%;
      left: $grid-gutter-20 / 2;

      transform: translateY(-50%);
      aspect-ratio: 1 / 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .vc-wrapper {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1050;
      margin-top: 5px;
    }

    ::v-deep .vc-container {
      background-color: $white;
      border: 1px solid $gray-200;
      box-shadow: $box-shadow-sm;
      border-radius: $btn-border-radius;
      min-width: 100% !important;
    }

    ::v-deep .picker-alert {
      margin-top: -5px;
      .alert {
        font-size: $font-size-sm;
        margin: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    @include media-breakpoint-down(sm) {
      .vc-wrapper {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
</style>
